import { render, staticRenderFns } from "./peaAuthorization.vue?vue&type=template&id=1871abaa&scoped=true"
import script from "./peaAuthorization.vue?vue&type=script&lang=js"
export * from "./peaAuthorization.vue?vue&type=script&lang=js"
import style0 from "./peaAuthorization.vue?vue&type=style&index=0&id=1871abaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871abaa",
  null
  
)

export default component.exports